import { AfterViewInit, ChangeDetectionStrategy, Component, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { HttpStatusCode } from 'axios';
import { DashboardInceptedApeService } from '../../dashboard-services/dashboard-incepted-ape/dashboard-incepted-ape.service';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { InceptedApeSummary } from '../../dashboard-interfaces/incepted-ape-summary.interface';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { InceptedApeByAdvisors } from '../../dashboard-interfaces/incepted-ape-by-advisors.interface';
import { InceptedApeByBranches } from '../../dashboard-interfaces/incepted-ape-by-branches.interface';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ViewInceptedApeBranchAdvisorsDialog } from '../../dashboard-dialogs/view-incepted-ape-branch-advisors/view-incepted-ape-branch-advisors.dialog';
import { DashboardManagerTeamService } from '../../dashboard-services/dashboard-manager-team/dashboard-manager-team.service';
import { ViewInceptedApeManagerAdvisorsDialog } from '../../dashboard-dialogs/view-incepted-ape-manager-advisors/view-incepted-ape-manager-advisors.dialog';
import { Router } from '@angular/router';
import { TabState } from '../../dashboard-interfaces/tab-state.interface';

@Component({
  selector: 'dashboard-incepted-ape',
  imports: [
    CommonModule,
    MatCardModule,
    MatExpansionModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    CurrencyPipe,
    ReactiveFormsModule,
    MatIconModule
  ],
  templateUrl: './incepted-ape.component.html',
  styleUrl: './incepted-ape.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InceptedApeComponent implements OnInit, AfterViewInit {

  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private dashboardInceptedApeService = inject(DashboardInceptedApeService);
  private dashboardManagerTeamService = inject(DashboardManagerTeamService);
  private readonly matDialog = inject(MatDialog);

  protected currentUserRole: string = '';

  protected totalMonthInceptedApe: number = 0;
  protected totalYearInceptedApe: number = 0;
  protected inceptedApeSummary: InceptedApeSummary = {
    monthSinglife: 0,
    monthNonsinglife: 0,
    monthSinglifeCase: 0,
    monthNonsinglifeCase: 0,
    yearSinglife: 0,
    yearNonsinglife: 0,
    yearSinglifeCase: 0,
    yearNonsinglifeCase: 0,
    yearTarget: 0
  };

  private inceptedApeByAdvisorData: InceptedApeByAdvisors[] = [];
  protected inceptedApeByAdvisorTableDisplayDataRow: string[] = [];
  protected inceptedApeByAdvisorTableDisplayFirstColumn: string[] = [];
  protected inceptedApeByAdvisorTableDisplaySecondColumn: string[] = ['monthSinglife', 'monthSinglifeCase', 'monthNonsinglife', 'monthNonsinglifeCase', 'yearSinglife', 'yearSinglifeCase', 'yearNonsinglife', 'yearNonsinglifeCase'];
  protected inceptedApeByAdvisorTableDataSource = new MatTableDataSource<InceptedApeByAdvisors>();

  private inceptedApeByBranchData: InceptedApeByBranches[] = [];
  protected inceptedApeByBranchTableDisplayColumn: string[] = ["branchName", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
  protected inceptedApeByBranchTableDataSource = new MatTableDataSource<InceptedApeByBranches>();

  private inceptedApeByManagerData: InceptedApeByAdvisors[] = [];
  protected inceptedApeByManagerTableDisplayDataRow: string[] = ["repCode", "personName", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
  protected inceptedApeByManagerTableDisplayFirstColumn: string[] = ['repCode', 'personName', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal'];
  protected inceptedApeByManagerTableDisplaySecondColumn: string[] = ['monthSinglife', 'monthSinglifeCase', 'monthNonsinglife', 'monthNonsinglifeCase', 'yearSinglife', 'yearSinglifeCase', 'yearNonsinglife', 'yearNonsinglifeCase'];
  protected inceptedApeByManagerTableDataSource = new MatTableDataSource<InceptedApeByAdvisors>();

  inceptedApeByAdvisorTableFilterFc = new FormControl("");
  inceptedApeByBranchTableFilterFc = new FormControl("");
  inceptedApeByManagerTableFilterFc = new FormControl("");

  setSprinner = signal(false);
  isInceptedApeByAdvisorTableHidden = signal(false);
  isInceptedApeByBranchTableHidden = signal(false);
  isInceptedApeByManagerTableHidden = signal(false);

  @ViewChild('inceptedApeByAdvisorTablePaginator')
  inceptedApeByAdvisorTablePaginator!: MatPaginator;
  @ViewChild('inceptedApeByAdvisorTableSort')
  inceptedApeByAdvisorTableSort = new MatSort();
  @ViewChild('inceptedApeByBranchTablePaginator')
  inceptedApeByBranchTablePaginator!: MatPaginator;
  @ViewChild('inceptedApeByBranchTableSort')
  inceptedApeByBranchTableSort = new MatSort();
  @ViewChild('inceptedApeByManagerTablePaginator')
  inceptedApeByManagerTablePaginator!: MatPaginator;
  @ViewChild('inceptedApeByManagerTableSort')
  inceptedApeByManagerTableSort = new MatSort();

  @Input('tabState')
  set tabState(state: TabState) {
    this.isCurrentTabActive = state.isActive;
    this.targetYear = state.targetYear;

    this.setAsCurrentTab();
  }

  protected inceptedApeMtdDisclaimer: string = "";
  protected inceptedApeYtdDisclaimer: string = "";

  protected isCurrentTabActive: boolean = false;
  protected targetYear: string = "";

  constructor() { }

  async ngOnInit(): Promise<void> {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();

    if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
      this.inceptedApeByAdvisorTableDisplayDataRow = ["repCode", "personName", "branch", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
      this.inceptedApeByAdvisorTableDisplayFirstColumn = ['repCode', 'personName', 'branch', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal'];
    }
    else {
      this.inceptedApeByAdvisorTableDisplayDataRow = ["repCode", "personName", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
      this.inceptedApeByAdvisorTableDisplayFirstColumn = ['repCode', 'personName', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal'];
    }
  }

  ngAfterViewInit(): void {
    this.inceptedApeByAdvisorTableDataSource.paginator = this.inceptedApeByAdvisorTablePaginator;
    this.inceptedApeByAdvisorTableDataSource.sort = this.inceptedApeByAdvisorTableSort;

    this.inceptedApeByBranchTableDataSource.paginator = this.inceptedApeByBranchTablePaginator;
    this.inceptedApeByBranchTableDataSource.sort = this.inceptedApeByBranchTableSort;

    this.inceptedApeByManagerTableDataSource.paginator = this.inceptedApeByManagerTablePaginator;
    this.inceptedApeByManagerTableDataSource.sort = this.inceptedApeByManagerTableSort;
  }

  async setAsCurrentTab(): Promise<void> {
    this.inceptedApeByAdvisorData = [];
    this.inceptedApeByBranchData = [];
    this.inceptedApeByManagerData = [];

    if (this.isCurrentTabActive) {
      await this.getDashboardInceptedApe();

      this.totalMonthInceptedApe = this.inceptedApeSummary.monthSinglife + this.inceptedApeSummary.monthNonsinglife;
      this.totalYearInceptedApe = this.inceptedApeSummary.yearSinglife + this.inceptedApeSummary.yearNonsinglife;

      if (this.inceptedApeByAdvisorData.length > 0) {
        // this.inceptedApeByAdvisorTableDataSource.data = this.inceptedApeByAdvisorData;
        this.__applyInceptedApeByAdvisorDataFilter();
      } else {
        this.isInceptedApeByAdvisorTableHidden.set(true);
      }

      if (this.inceptedApeByBranchData.length > 0) {
        // this.inceptedApeByBranchTableDataSource.data = this.inceptedApeByBranchData;
        this.__applyInceptedApeByBranchDataFilter();
      } else {
        this.isInceptedApeByBranchTableHidden.set(true);
      }

      if (['Director'].includes(this.currentUserRole)) {
        await this.getDashboardDirectorwiseManagers();
        // this.inceptedApeByManagerTableDataSource.data = this.inceptedApeByManagerData;
        this.__applyInceptedApeByManagerDataFilter();
      } else {
        this.isInceptedApeByManagerTableHidden.set(true);
      }
    }
  }

  async getDashboardInceptedApe() {
    this.setSprinner.set(true);

    const responseData = await this.dashboardInceptedApeService
      .getDashboardInceptedApe(Number.parseInt(this.targetYear))
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      // Manager, Director : apedata, apesummary
      // Agent : apesummary
      // Corporate : branchdata, corporateapedata
      // BDM : bdmapedata, bdmbranchreporting
      if (this.currentUserRole === 'Corporate') {
        this.mapApeSummaryData(responseData.data.responsedata.corporateapedata[0], responseData.data.responsedata.projectconfiguration);
        this.__formatInceptedApeByBranchData(responseData.data.responsedata.branchdata, responseData.data.responsedata.affinitybranch);
      }
      else if (this.currentUserRole === 'BDM') {
        this.mapApeSummaryData(responseData.data.responsedata.bdmapedata[0], responseData.data.responsedata.projectconfiguration);
        this.__formatInceptedApeByBranchData(responseData.data.responsedata.bdmbranchreporting, responseData.data.responsedata.affinitybranch);
      }
      else if (['Manager', 'Director'].includes(this.currentUserRole)) {
        this.__formatInceptedApeByAdvisorData(responseData.data.responsedata.apedata);
        this.mapApeSummaryData(responseData.data.responsedata.apesummary[0], responseData.data.responsedata.projectconfiguration);
      }
      else {
        this.mapApeSummaryData(responseData.data.responsedata.apesummary[0], responseData.data.responsedata.projectconfiguration);
      }

      this.setDisclaimers(responseData.data.responsedata.disclamirdata);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async getDashboardDirectorwiseManagers() {
    this.setSprinner.set(true);

    const responseData = await this.dashboardManagerTeamService
      .getDashboardInceptedApeDirectorwiseManager()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      let managerTableData: any[] = responseData.data.responsedata;
      managerTableData.forEach((manager) => {
        this.inceptedApeByManagerData.push({
          repCode: manager.piasRepCode.toString(),
          personName: manager.agentRealName.toString(),
          branch: manager.branch.toString(),
          monthSinglife: Number.parseInt(manager.mtdSinglife.toString()),
          monthSinglifeCase: Number.parseInt(manager.mtdSinglifeCase.toString()),
          monthNonsinglife: Number.parseInt(manager.mtdNonSinglife.toString()),
          monthNonsinglifeCase: Number.parseInt(manager.mtdNonSinglifeCase.toString()),
          yearSinglife: Number.parseInt(manager.ytdSinglife.toString()),
          yearSinglifeCase: Number.parseInt(manager.ytdSinglifeCase.toString()),
          yearNonsinglife: Number.parseInt(manager.ytdNonSinglife.toString()),
          yearNonsinglifeCase: Number.parseInt(manager.ytdNonSinglifeCase.toString()),
          yearTarget: 0,
          yearTotal: Number.parseInt(manager.ytdSinglife.toString()) + Number.parseInt(manager.ytdNonSinglife.toString()),
          userGroup: manager.userGroup.toString()
        });
      });

      // this.inceptedApeByManagerData = this.inceptedApeByManagerData.filter(item => item.userGroup !== 'Affinity');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  clearSearch() {
    this.inceptedApeByAdvisorTableFilterFc.setValue('');
    this.__applyInceptedApeByAdvisorDataFilter();
  }

  clearBranchSearch() {
    this.inceptedApeByBranchTableFilterFc.setValue('');
    this.__applyInceptedApeByBranchDataFilter();
  }
  clearManagerSearch() {
    this.inceptedApeByManagerTableFilterFc.setValue('');
    this.__applyInceptedApeByManagerDataFilter();
  }

  private setDisclaimers(disclaimer: any[]) {
    if (this.targetYear == new Date().getFullYear().toString()) {
      this.inceptedApeMtdDisclaimer = disclaimer.filter(dmItem => dmItem.dmType === "incepted_ape_mtd")[0].dmText.toString();
      this.inceptedApeYtdDisclaimer = disclaimer.filter(dmItem => dmItem.dmType === "incepted_ape_ytd")[0].dmText.toString();

    } else {
      this.inceptedApeMtdDisclaimer = "The Information is based on data as at 31/12/2025 for Singlife and 30/12/2025 for Non-Singife.";
      this.inceptedApeYtdDisclaimer = "The Information is based on data as at 31/12/2025 for Singlife and 30/12/2025 for Non-Singife.";
    }
  }

  private mapApeSummaryData(apeData: any, projConfig: any[]) {
    this.inceptedApeSummary = {
      monthSinglife: Number.parseInt(apeData.mtdSinglife),
      monthNonsinglife: Number.parseInt(apeData.mtdNonSinglife),
      monthSinglifeCase: Number.parseInt(apeData.mtdSinglifeCase),
      monthNonsinglifeCase: Number.parseInt(apeData.mtdNonSinglifeCase),
      yearSinglife: Number.parseInt(apeData.ytdSinglife),
      yearNonsinglife: Number.parseInt(apeData.ytdNonSinglife),
      yearSinglifeCase: Number.parseInt(apeData.ytdNonSinglifeCase),
      yearNonsinglifeCase: Number.parseInt(apeData.ytdSinglifeCase),
      yearTarget: Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Incepted_APE_Year_Target")[0].pjConfValue)
    };
  }

  private __formatInceptedApeByAdvisorData(inceptedApeByAdvisorDataList: any[]) {
    inceptedApeByAdvisorDataList.forEach((inceptedApeByAdvisorDataItem: any) => {
      this.inceptedApeByAdvisorData.push({
        repCode: inceptedApeByAdvisorDataItem.piasRepCode,
        personName: inceptedApeByAdvisorDataItem.agentRealName.toString().trim(),
        branch: inceptedApeByAdvisorDataItem.branch.toString().trim(),
        monthSinglife: inceptedApeByAdvisorDataItem.mtdSinglife,
        monthSinglifeCase: inceptedApeByAdvisorDataItem.mtdSinglifeCase,
        monthNonsinglife: inceptedApeByAdvisorDataItem.mtdNonSinglife,
        monthNonsinglifeCase: inceptedApeByAdvisorDataItem.mtdNonSinglifeCase,
        yearSinglife: inceptedApeByAdvisorDataItem.ytdSinglife,
        yearSinglifeCase: inceptedApeByAdvisorDataItem.ytdSinglifeCase,
        yearNonsinglife: inceptedApeByAdvisorDataItem.ytdNonSinglife,
        yearNonsinglifeCase: inceptedApeByAdvisorDataItem.ytdNonSinglifeCase,
        yearTarget: inceptedApeByAdvisorDataItem.yealyTarget,
        yearTotal: (inceptedApeByAdvisorDataItem.ytdSinglife + inceptedApeByAdvisorDataItem.ytdNonSinglife),
        userGroup: inceptedApeByAdvisorDataItem.userGroup.toString()
      });
    });

    // this.inceptedApeByAdvisorData = this.inceptedApeByAdvisorData.filter(item => item.userGroup !== 'Affinity');
  }

  private __formatInceptedApeByBranchData(inceptedApeByBranchDataList: any[], affinitybranch: any[]) {
    inceptedApeByBranchDataList.forEach((inceptedApeByBranchDataItem: any) => {
      this.inceptedApeByBranchData.push({
        branchName: inceptedApeByBranchDataItem.branch,
        monthSinglife: inceptedApeByBranchDataItem.mtdSinglife,
        monthSinglifeCase: inceptedApeByBranchDataItem.mtdSinglifeCase,
        monthNonsinglife: inceptedApeByBranchDataItem.mtdNonSinglife,
        monthNonsinglifeCase: inceptedApeByBranchDataItem.mtdNonSinglifeCase,
        yearSinglife: inceptedApeByBranchDataItem.ytdSinglife,
        yearSinglifeCase: inceptedApeByBranchDataItem.ytdSinglifeCase,
        yearNonsinglife: inceptedApeByBranchDataItem.ytdNonSinglife,
        yearNonsinglifeCase: inceptedApeByBranchDataItem.ytdNonSinglifeCase,
        yearTarget: inceptedApeByBranchDataItem.yealyTarget,
        yearTotal: (inceptedApeByBranchDataItem.ytdSinglife + inceptedApeByBranchDataItem.ytdNonSinglife)
      });
    });

    // this.inceptedApeByBranchData = this.inceptedApeByBranchData.filter(branch => !affinitybranch.find(item => item.branchName === branch.branchName));
  }

  protected __applyInceptedApeByAdvisorDataFilter() {
    let filterValue: string = this.inceptedApeByAdvisorTableFilterFc.value?.toString() || '';

    let tempInceptedApeByAdvisorTableData: InceptedApeByAdvisors[] = [];

    if (filterValue) {
      tempInceptedApeByAdvisorTableData = this.inceptedApeByAdvisorData.filter(apeData =>
        apeData.repCode.toString().includes(filterValue)
        || apeData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempInceptedApeByAdvisorTableData = this.inceptedApeByAdvisorData;
    }

    this.inceptedApeByAdvisorTableDataSource.data = tempInceptedApeByAdvisorTableData;
  }

  protected __applyInceptedApeByBranchDataFilter() {
    let filterValue: string = this.inceptedApeByBranchTableFilterFc.value?.toString() || '';

    let tempInceptedApeByBranchTableData: InceptedApeByBranches[] = [];

    if (filterValue) {
      tempInceptedApeByBranchTableData = this.inceptedApeByBranchData.filter(apeData =>
        apeData.branchName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempInceptedApeByBranchTableData = this.inceptedApeByBranchData;
    }

    this.inceptedApeByBranchTableDataSource.data = tempInceptedApeByBranchTableData;
  }

  protected __applyInceptedApeByManagerDataFilter() {
    let filterValue: string = this.inceptedApeByManagerTableFilterFc.value?.toString() || '';

    let tempInceptedApeByManagerTableData: InceptedApeByAdvisors[] = [];

    if (filterValue) {
      tempInceptedApeByManagerTableData = this.inceptedApeByManagerData.filter(apeData =>
        apeData.repCode.toString().includes(filterValue)
        || apeData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempInceptedApeByManagerTableData = this.inceptedApeByManagerData;
    }

    this.inceptedApeByManagerTableDataSource.data = tempInceptedApeByManagerTableData;
  }

  protected __displayBranchWiseAdvisors(brancName: string) {
    const viewBranchAdvisorsDialogRef = this.matDialog.open(ViewInceptedApeBranchAdvisorsDialog, {
      data: {
        branchName: brancName
      },
      width: "calc(100vw - 30px)",
      maxWidth: "calc(100vw - 30px)",
      height: "calc(100vh - 75px)",
      panelClass: 'branch-popup-dialog',
      maxHeight: "calc(100vh - 75px)",
      position: {
        bottom: "20px"
      }
    });
  }

  protected __displayManagerWiseAdvisors(managerRepCode: string, managerName: string) {
    const viewManagerAdvisorsDialogRef = this.matDialog.open(ViewInceptedApeManagerAdvisorsDialog, {
      data: {
        managerRepCode: managerRepCode,
        managerName: managerName
      },
      width: "calc(100vw - 30px)",
      maxWidth: "calc(100vw - 30px)",
      height: "calc(100vh - 75px)",
      panelClass: 'branch-popup-dialog',
      maxHeight: "calc(100vh - 75px)",
      position: {
        bottom: "20px"
      }
    });
  }
}
